<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <section class="col-lg-12 connectedSortable table-area mt-3 pr-0 pl-0 mb-3">
                    <div class="card">
                        <div class="card-body table-responsive table-head">
                            <div class="row bor-bot">
                                <div class="col-md-8 pl-0 pb-3">
                                    <h1 class="m-0 text-dark pt-2 pb-1">Clubs</h1>
                                </div>
                            </div>
                            <div class="table-responsive mt-3">
                                <div class="data-tablebutn pb-3"></div>
                                <table class="table table-sm table-bordered table-hover" id="volunteerClubs">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>Club Name</th>
                                            <th>City</th>
                                            <th>State</th>
                                            <th>Club Expiration Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="5" class="text-center">
                                                Please wait.... <i class="fa fa-circle-notch fa-spin"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';
import moment from 'moment';
export default {
    name: "VolunteerClubsList",
    data() {
        return {
            table: null
        };
    },
    methods: {
        fetchClubs() {
            this.table = $("#volunteerClubs").DataTable({
                processing: true,
                serverSide: true,
                bFilter: true,
                responsive: true,
                ajax: {
                    url: process.env.VUE_APP_URL + "api/volunteers/clubs",
                    headers: this.adminHeaders,
                    data: function (d) {
                        d.dt = true
                    }
                },
                columns: [
                    {
                        data: "name", name: "name", render: (data) => {
                            return data || "N/A";
                        }
                    },
                    {
                        data: "city", name: "city", render: (data) => {
                            return data || "N/A";
                        }
                    },
                    {
                        data: "state", name: "state", render: (data) => {
                            return data || "N/A";
                        }
                    },
                    {
                        data: "expiration_date", name: "expiration_date", render: (data) => {
                            return (data ? moment(data).format("MM/DD/YYYY") : "N/A") || "N/A";
                        }
                    },
                    {
                        data: "actions", name: "actions", orderable: false, render: (data, type, row, meta) => {
                            let actions = '';
                            if (data?.viewMemberRoster) {
                                actions += `<a class="btn btn-sm btn-dark view-member-roster mr-2" href="/volunteer/club/${data.id}/member-roster">
                                                <i class="fa fa-eye"></i> Member Roster
                                            </a>`;
                            }
                            if (data?.viewOfficialRoster) {
                                actions += `<a class="btn btn-sm btn-danger view-official-roster" href="/volunteer/club/${row.team_id}/official-roster">
                                                <i class="fa fa-eye"></i> Official Roster
                                            </a>`;
                            }
                            return actions;
                        }
                    }
                ],
                order: [[0, "asc"]],
            });
        }
    },
    mounted() {
        this.fetchClubs();
    }
}
</script>